import React from 'react'
import styles from '@bt-react/styles'
import { Input } from 'reactstrap'
import { TextfieldProps } from './types'

export default class Textfield extends React.Component<TextfieldProps> {

  onKeyPress = (event) => {

    if (event && event.which === 13) {

      event.preventDefault()

    }
    if (this.props.onKeyPress) {

      this.props.onKeyPress(event)

    }

  }

  render () {

    if (this.props.reducedAsscessUserRole && this.props.readOnly) {
      return (
        <div
          data-bdd={this.props.dataBdd && this.props.dataBdd !== 'title' &&  this.props.dataBdd !== 'presenter' && this.props.dataBdd !== 'clientBookingReference' ? this.props.dataBdd : 'textfield'}>
          {this.props.value && this.props.value.charAt(0).toUpperCase() + this.props.value.slice(1)}
        </div>
      )
    }

    return (
      <Input
        autoFocus={this.props.autoFocus}
        innerRef={this.props.innerRef}
        data-bdd={this.props.dataBdd && this.props.dataBdd !== 'title' &&  this.props.dataBdd !== 'presenter' && this.props.dataBdd !== 'clientBookingReference' ? this.props.dataBdd : 'textfield'}
        onKeyPress={this.onKeyPress}
        className={this.props.className}
        onFocus={(ev) => {

          this.props.readOnly && ev.target.blur()
          this.props.onFocus && this.props.onFocus(ev)

        }}
        onClick={this.props.onClick}
        onChange={({ target }) => {

          this.props.onChange && this.props.onChange(this.props?.id ?? '', target.value)

        }}
        onBlur={({ target }) => {

          if (this.props.onBlur) this.props.onBlur(this.props?.id ?? '')

        }}
        id={this.props.id}
        value={this.props.value}
        placeholder={this.props.placeholder}
        cssModule={styles}
        invalid={!!(this.props.error)}
        disabled={this.props.disabled}
        autoComplete={this.props.autoComplete}
        name={this.props.name}
        type={this.props.type}
        maxLength={this.props.maxLength}
        onKeyUp={this.props.onKeyUp}
      />
    )

  }

}
